import { refreshHycFinanceCounts } from "@/utils/hyc-finance-count";
const permission = "manage_bill";

export default [
    {
        path: "/finance/hyc",
        name: "finance-hyc",
        component: () => import("@/layouts/default.vue"),
        redirect: "/finance/hyc/overview",
        meta: { title: "HYC 财务", parent: "finance", icon: "finance-bill", permission },
        beforeEnter: async () => {
            // 统计暂不可用不妨碍打开单据；工作台会展示具体错误与重试。
            await refreshHycFinanceCounts().catch(() => {});
        },
        children: [
            {
                path: "overview", name: "finance-hyc-overview",
                component: () => import("@/views/fms/hyc-finance/overview/index.vue"),
                meta: { title: "财务工作台", icon: "index", permission },
            },
            {
                path: "accounts", name: "finance-hyc-accounts",
                component: () => import("@/views/fms/hyc-finance/billing/accounts.vue"),
                meta: { title: "计费账户", icon: "finance-bill", permission },
            },
            {
                path: "accounts/:id(\\d+)", name: "finance-hyc-account", hidden: true,
                component: () => import("@/views/fms/hyc-finance/billing/account-detail.vue"),
                meta: { title: "计费账户明细", parent: "hyc", activeMenu: "/hyc/customers/organizations", permission: "", permissionsAny: ["manage_after_sale", "manage_bill"] },
            },
            {
                path: "account-records/:accountId(\\d+)", name: "finance-hyc-account-record", hidden: true,
                component: () => import("@/views/fms/hyc-finance/billing/account-detail.vue"),
                meta: { title: "历史账户明细", activeMenu: "/finance/hyc/accounts", permission },
            },
            {
                path: "refunds", name: "finance-hyc-refunds",
                component: () => import("@/views/fms/hyc-finance/billing/refunds.vue"),
                meta: { title: "退款与余额退回", icon: "finance-bill-pay", permission },
            },
            {
                path: "refunds/:id(\\d+)", name: "finance-hyc-refund", hidden: true,
                component: () => import("@/views/fms/hyc-finance/billing/refund-detail.vue"),
                meta: { title: "退款详情", activeMenu: "/finance/hyc/refunds", permission },
            },
            {
                path: "withdrawals/:id(\\d+)", name: "finance-hyc-withdrawal", hidden: true,
                component: () => import("@/views/fms/hyc-finance/billing/withdrawal-detail.vue"),
                meta: { title: "余额退回详情", activeMenu: "/finance/hyc/refunds", permission },
            },
            {
                path: "reward-withdrawals", name: "finance-hyc-reward-customers",
                component: () => import("@/views/fms/hyc-finance/reward/customers.vue"),
                meta: { title: "客户奖励提现", icon: "finance-bill-pay", permission },
            },
            {
                path: "actors", name: "finance-hyc-reward-actors",
                component: () => import("@/views/fms/hyc-finance/reward/actors.vue"),
                meta: { title: "销售与分销商结算", icon: "finance-bill-statement", permission },
            },
            {
                path: "actors/:id(\\d+)", name: "finance-hyc-reward-actor", hidden: true,
                component: () => import("@/views/fms/hyc-finance/reward/actor-detail.vue"),
                meta: { title: "人员奖励明细", activeMenu: "/finance/hyc/actors", permission },
            },
            {
                path: "reward-withdrawals/:id(\\d+)", name: "finance-hyc-reward-withdrawal", hidden: true,
                component: () => import("@/views/fms/hyc-finance/reward/withdrawal-detail.vue"),
                meta: { title: "奖励付款详情", activeMenu: "/finance/hyc/actors", permission },
            },
            {
                path: "exceptions", name: "finance-hyc-exceptions",
                component: () => import("@/views/fms/hyc-finance/exceptions/index.vue"),
                meta: { title: "异常与核对", icon: "finance-bill-exception", permission },
            },
        ],
    },
];
